export const operationCompanyPostalCode = "〒413-0014";
export const atamiTourismPhoneNumber = "0557-85-2222";
export const atamiFAXNumber = "0557-85-2211";
export const atamiMailAddress = "info@goatami.jp";

export const latSakurazaka = 35.0958226;
export const lngSakurazaka = 139.0735121;
